(function () {
  var header = document.querySelector('[data-ib-header]');
  if (!header) return;

  var mobileMenu = document.querySelector('[data-ib-mobile-menu]');
  var openButton = document.querySelector('[data-ib-menu-open]');
  var closeButton = document.querySelector('[data-ib-menu-close]');

  function syncHeader() {
    if (window.scrollY > 40) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }

  function setMenu(open) {
    header.classList.toggle('is-open', open);
    if (mobileMenu) {
      mobileMenu.classList.toggle('is-open', open);
      mobileMenu.setAttribute('aria-hidden', open ? 'false' : 'true');
    }
    if (openButton) {
      openButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    document.documentElement.classList.toggle('ib-menu-open', open);
  }

  syncHeader();
  window.addEventListener('scroll', syncHeader, { passive: true });

  if (openButton) {
    openButton.addEventListener('click', function () {
      setMenu(true);
    });
  }

  if (closeButton) {
    closeButton.addEventListener('click', function () {
      setMenu(false);
    });
  }

  if (mobileMenu) {
    mobileMenu.addEventListener('click', function (event) {
      if (event.target.tagName === 'A') setMenu(false);
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setMenu(false);
  });
})();
